import { useFeatureFlags } from 'feature-flags';

export const useRedactPII = () => {
  const { REDACT_PII } = useFeatureFlags(['REDACT_PII']);

  return {
    isRedactPII: !!REDACT_PII,
  };
};
